import { Box, Group, Text, Title } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { KapaLogoWordmark } from 'components/common/kapa-logo-wordmark';

interface MessageProps {
  title: string;
  message: React.ReactNode;
  variant?: 'error' | 'info';
}

export const KapaMessage = ({
  title,
  message,
  variant = 'info',
}: MessageProps) => {
  const isError = variant === 'error';

  return (
    <Box
      display="flex"
      h="100vh"
      p="24px"
      style={{ justifyContent: 'center', alignItems: 'center' }}
    >
      <Box
        display="flex"
        ta="center"
        maw="500px"
        w="100%"
        style={{
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '48px',
        }}
      >
        <KapaLogoWordmark
          className="text-foreground h-auto w-[150px]"
          aria-label="Kapa.ai logo"
        />
        <Box
          display="flex"
          style={{
            flexDirection: 'column',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          <Group gap="xs">
            {isError && (
              <IconAlertCircle
                size={18}
                style={{ color: 'var(--color-foreground-secondary)' }}
              />
            )}
            <Title order={6} fw={500}>
              {title}
            </Title>
          </Group>
          <Text size="sm" lh={1.5} c="var(--color-foreground-secondary)">
            {message}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
